export default __webpack_public_path__ + "static/media/09.04840cf2.mp4";